// Turns anything thrown by the API layer into a sentence worth showing a user.
//
// apiClient already rejects with a normalized { status, message, data } shape and
// the server only sends messages it wrote for people, so `message` is safe to
// display as-is. This guards the edges: a raw Error that escaped the API layer,
// a string, or nothing at all.
export const GENERIC_ERROR = 'Something went wrong. Please try again.';

// Messages axios generates itself. They describe the transport, not the problem
// the user can do anything about, so they never reach the screen.
const TECHNICAL = /^(Network Error|timeout of |Request failed with status|ECONN|ERR_)/i;

export default function getErrorMessage(err, fallback = GENERIC_ERROR) {
  if (!err) return fallback;
  if (typeof err === 'string') return err.trim() || fallback;

  const message = err.message;
  if (typeof message !== 'string') return fallback;

  const trimmed = message.trim();
  if (!trimmed || TECHNICAL.test(trimmed)) return fallback;
  return trimmed;
}

// Same message, with the backend's correlation ID appended when there is one.
// Support can trace that ID straight to the server log for the failed request,
// so it is worth showing on the flows people actually call in about.
export function errorWithReference(err, fallback = GENERIC_ERROR) {
  const message = getErrorMessage(err, fallback);
  const ref = err?.correlationId;
  return ref ? `${message}\nReference ID: ${ref}` : message;
}
